import React from 'react';
import { Security } from 'paycor-react-oidc';
import { onAuthFailed, onAuthError } from 'utils/authentication';
import { API_URL } from 'constants/apis';
import config from 'config';
import LoadingStatus from '@paycor/pds-loading-status';

import Header from 'pages/Header';
import Routes from 'root-routes';

import 'App.scss';
import { SessionTimeout } from '@paycor/design-system';
import { GlobalProvider } from './globalContext';
import { InitializeReactI18n } from './utils/i18n';
import { useTranslation } from 'react-i18next';
import { getTranslatedText } from 'utils/i18n';


const App = () => {
	const { t } = useTranslation();
	InitializeReactI18n();
	const {
		APIM_SUBSCRIPTION_KEY,
		HOST: { BASE_SECURE_URL }
	} = config;
	const { ACCOUNTS } = API_URL;

	return (
		<Security
			settings={config.securitySettings}
			onUnAuthorizedCallback={onAuthFailed}
			onAuthErrorCallback={onAuthError}
			consoleLogsEnabled={true}
			loaderComponent={<LoadingStatus loadingMessage={getTranslatedText(t, 'Loading')}/>}
		>
			<SessionTimeout applicationUrl={BASE_SECURE_URL} refreshUrl={`${ACCOUNTS}/`} APIm={APIM_SUBSCRIPTION_KEY}>
				<Header />
				<GlobalProvider>
					<app-main>
						<Routes />
					</app-main>
				</GlobalProvider>
			</SessionTimeout>
		</Security>
	);
};

export default App;
